/**
 * Authentication related constants
 */
export const AUTH_CONSTANTS = {
  /** OTP countdown duration in milliseconds (90 seconds) */
  OTP_COUNTDOWN_MS: 90_000,
  
  /** Minimum password length required for signup */
  MIN_PASSWORD_LENGTH: 6,

  /** OTP length (6 digits) */
  OTP_LENGTH: 6,
  
  /** OTP countdown duration in seconds */
  OTP_COUNTDOWN_SECONDS: 90
} as const;

/**
 * Storage keys used across authentication flows
 */
export enum SignUpStorageKey {
  SIGNUP_EMAIL = 'signupEmail',
  EMAIL_ID = 'emailId',
  OTP_TOKEN = 'otpToken',
  USER_ID = 'userId',
  FULL_NAME = 'signupFullName',
  COMPANY_NAME = 'signupCompanyName',
  REVIEWER_EMAIL_ID = 'reviewerEmailId',
  PASSWORD = 'signupPassword',
  COUNTDOWN_END_TIME = 'otpCountdownEndTime',
  OTP_PURPOSE = 'otpPurpose'
}

export enum ForgetPasswordStorageKey {
  OTP_TOKEN = 'otpToken',
  EMAIL_ID = 'emailId',
  COUNTDOWN_END_TIME = 'otpCountdownEndTime',
  OTP_PURPOSE = 'otpPurpose'
}


export enum LoginStorageKey {
  OTP_TOKEN = 'otpToken',
  EMAIL_ID = 'emailId',
  USER_ID = 'userId',
  COUNTDOWN_END_TIME = 'otpCountdownEndTime',
  OTP_PURPOSE = 'otpPurpose',
  SECURITY_VERIFICATION = 'Security-Verification'
}

export enum TfaStorageKey {
  OTP_TOKEN = 'otpToken',
  EMAIL_ID = 'emailId',
  COUNTDOWN_END_TIME = 'otpCountdownEndTime',
  OTP_PURPOSE = 'otpPurpose',
  SECURITY_VERIFICATION = 'Security-Verification'
}

export enum Role {
    PAY10_ADMIN = 'Developer Pay10 Admin',
    DEVELOPER_ADMIN = 'Developer Admin',
    DEVELOPER = 'Developer'
}

